import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {EntityKey} from '../entity/entity';
import {EntityProcessing} from '../entity/entity-processing';

@Service()
export class EntityProcessingService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getEntityProcessingRecords(entityKey: EntityKey): Observable<EntityProcessing[]> {
    const url = this.urlBase + 'entityProcessing/entity/' + entityKey.entityId + '/' + entityKey.entityRevision;
    return this.http.get<EntityProcessing[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
